import { Component, OnInit } from '@angular/core';
import { ToolbarDirective } from '@otas/utils/directives/styles/toolbar.directive';
import { PermissionService } from 'guards/permission-service';
import { ModuleVersionService } from '../services/module-version.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    providers: [ToolbarDirective],
    standalone: false
})
export class HomeComponent implements OnInit {

  constructor(private toolbar: ToolbarDirective, private permission: PermissionService,
    private moduleVersionService: ModuleVersionService) { }

  /** Pooja tile target - follows the VAZHIPADU module version (V2 default). */
  get bookingRoute(): string {
    return this.moduleVersionService.bookingRoute();
  }

  ngOnInit() {
    // if (!this.permission.hasToken()) {
    //   this.toolbar.openLogin();
    // }
  }

  print(): void {
    // window.print();
  }

}
